// @ts-nocheck
import React, {useState, useEffect, useRef} from 'react'
import { usePermissions } from '../../../context/PermissionsContext';
import {useParams} from "react-router";
import useTargetingPermissions from '../../TargetingV2/hooks/useTargetingPermissions'
import styles from './css/Search.module.css'
import TopBar from '../../../components/TopBar'
import Results from '../../../components/Results'
import Titles from './components/ResultTitles'
import Pagination from '../../../components/Pagination'
import Spinner from '../../../components/Spinner'
import apiFetch from '../../../api/apiFetch'
import Field from '../../../components/Field'
import states from '../../../lookup/states.json'
import ResultHCP from './components/ResultHCP'
import ResultHCO from './components/ResultHCO'
import StatusBar from '../../TargetingV2/components/StatusBar'
import Table from '../../../components/Table'
import SpecialtyLookUpDerm from '../../../globalcomponents/SpecialtyLookUpDerm';

function Search(props) {

    const permissions = usePermissions();
    const { isAdminUser, isMultiExerciseUser } = useTargetingPermissions()
    const currentExercise = props.exercise

    const [config, setConfig] = useState()
    const [id, setId] = useState(props.exercise?.ID)
    const [targetexid, settargetId] = useState(props.exercise?.TARGETING_EXERCISE_ID)
    const [terrID, setTerrID] = useState('')
    const [data, setData] = useState([])
    const [prevData, setPrevData] = useState([])
    const [uniqueDegrees] = useState(['MD', 'PA', 'NP', 'APRN', 'DO', 'RN', 'PHAR'])
    const [currentPage, setCurrentPage] = useState(0)
    const [resultsPerPage, setResultsPerPage] = useState(20)
    const [totalResults, setTotalResults] = useState(0)
    const [searchParams, setSearchParams] = useState({
        FIRST_NAME: '',
        LAST_NAME: '',
        DEGREE: '',
        SPECIALTY: '',
        CURRENT_TARGET_TYPE: '',
        CHANGED_TARGET_VALUE: '',
        CITY: '',
        STATE: '',
        TGT: ''
    })
    const [status, setStatus] = useState()
    const [perTargetTotals, setPerTargetTotals] = useState()
    const [lock, setLock] = useState()
    const [loaded, setLoaded] = useState(false)
    const {idSlug, terrSlug} = useParams()
    const [options, setOptions] = useState()
    const [resetSort, setResetSort] = useState(false)
    const isMounted = useRef(false)

    const getTotals = (exTerr, exId) => {
        exTerr = terrID ? terrID : exTerr
        exId = currentExercise.TARGETING_EXERCISE_ID

        apiFetch('/api/v2/targeting/get-current-totals', { user: props.user.userName, terr: exTerr, id: exId, team: currentExercise.TEAM, role: props.user.role }).then((rows) => {
            if (!Array.isArray(rows) || rows.length === 0) return
            const typeCounts = {}
            let STATUS_ID = 1
            rows.forEach((row, i) => {
                if (i === 0) STATUS_ID = row.STATUS_ID ?? 1
                if (row.TARGET_TYPE) {
                    typeCounts[row.TARGET_TYPE] = {
                        current: row.CURRENT_TOTAL ?? 0,
                        final: row.FINAL_TOTAL ?? 0,
                        startCall: row.START_CALL_TOTAL ?? 0,
                    }
                }
            })
            setStatus({ typeCounts, STATUS_ID })
        })

        apiFetch('/api/v2/targeting/get-per-target-totals', { id: exId, terr: exTerr }).then((data) => {
            if(data) {
                setPerTargetTotals(data)
            }
        })
    }

    const search = (terrOverride) => {
        setResetSort(true)
        setLoaded(false)
        const effectiveTerrID = terrOverride !== undefined ? terrOverride : terrID

        if (effectiveTerrID !== '' || (isAdminUser && id != undefined && id != 0)) {

            let request = {
                ...searchParams,
                id: id,
                terr: effectiveTerrID,
                type: currentExercise.CUSTOMER_TYPE,
                USER_NAME: props.user.userName,
                role: props.user.role
            }
            apiFetch(`/api/v2/targeting/get-source-table-data`, request).then((data) => {
                if (data.length > 0) {
                    for (let i = 0; i < data.length; i++) {
                        let customColumns
                        if (data[i].CUSTOM_COLUMNS) {
                            customColumns = JSON.parse(data[i].CUSTOM_COLUMNS)
                        }
                        data[i] = {
                            ...data[i],
                            ...customColumns
                        }
                    }
                    setData(data)
                    setLoaded(true)

                    if (currentPage !== 0) {
                        setCurrentPage(0)
                    }
                }
                else {
                    setLoaded(false)
                }
            })

        }

    }

    const clear = () => {
        setSearchParams({
            FIRST_NAME: '',
            LAST_NAME: '',
            DEGREE: '',
            SPECIALTY: '',
            CURRENT_TARGET_TYPE: '',
            CHANGED_TARGET_VALUE: '',
            CITY: '',
            STATE: '',
            TGT: ''
        })
    }

    useEffect(() => {
        if (!isMounted.current) return
        search()
    }, [searchParams])

    useEffect(() => {
        if (prevData?.length === 0 && data?.length > 0) {
            setPrevData(data)
        }
    }, [data, prevData])

    useEffect(() => {
        setTotalResults(data.length)
    }, [data.length])

    useEffect(() => {
        if ((isAdminUser || isMultiExerciseUser) && Array.isArray(props.exercise)) {
            apiFetch('/api/v2/targeting/approval-check', { ID: currentExercise.ID }).then((data) => {
                props.setApproved(data.length > 0)
            })
        }
    }, [])

    useEffect(() => {
        if (!props.approved) {
            //statusLocks
            if (status) {
                if (permissions.targeting.search.statusLocks.general.oneTwo.includes(props.user.role) && (status.STATUS_ID === 1 || status.STATUS_ID === 2)) {
                    setLock(false)
                }
                else if (permissions.targeting.search.statusLocks.general.threeFive.includes(props.user.role) && (status.STATUS_ID === 3 || status.STATUS_ID === 5)) {
                    setLock(false)
                }
                else if (permissions.targeting.search.statusLocks.admin.four.includes(props.user.role) && (status.STATUS_ID === 4 )) {
                    setLock(false)
                }
                else if (permissions.targeting.search.statusLocks.admin.five.includes(props.user.role) && (status.STATUS_ID === 5)) {
                    setLock(true)
                }
                else if (permissions.targeting.search.statusLocks.general.five.includes(props.user.role) && (status.STATUS_ID === 5)) {
                    setLock(false)
                }
                else {
                    //console.log(props.user.role);
                    setLock(true)
                }
            }
        }
    }, [status, props.approved])

    useEffect(() => {

        const id = currentExercise.ID
        const exid = currentExercise.TARGETING_EXERCISE_ID
        const terr = terrSlug
            ? terrSlug
            : (props.user.terr != "")
                ? props.user.terr
                : `${currentExercise.TEAM}`

        setId(id)
        settargetId(exid)
        setTerrID(terr)
        getTotals(terr, exid)

        if (isAdminUser && Array.isArray(props.exercise)) {
            props.setBackUrl(`/targeting/admin/${id}`)
        }

        let tempConfig = JSON.parse(currentExercise.COLUMNS)

        for (let i = 0; i < Object.keys(tempConfig).length; i++) {
            const element = Object.values(tempConfig)[i]
            if (["Multiple"].includes(element.col)) {
                element.left = true
                element.sortBy = "LAST_NAME"
            }
            else if (element.col === "CHANGED_TARGET_VALUE") {
                element.sortBy = "TARGET_TYPE"
            }
        }
        setConfig(tempConfig)
        isMounted.current = true
        search(terr)
        apiFetch(`/api/v2/admin/exerciseadmin/get-reasons`,
            (data) => {
            setOptions({
                upgrade: data.filter(r => r.IS_UPGRADE).map(r => r.REASON),
                downgrade: data.filter(r => !r.IS_UPGRADE).map(r => r.REASON),
            })
        })
    }, [])

    let specialtyTeam31Options = [
        <option key="" value=""></option>,
        <option key="ALL" value="ALL">ALL</option>,
        <option key="AO" value="A/O">A/O</option>,
        <option key="DERM" value="DERM">DERM</option>,
        <option key="NPPA" value="NP/PA">NP/PA</option>,
        <option key="PCP" value="PCP">PCP</option>,
        <option key="PED" value="PED">PED</option>
    ]

    if (!config) {
        return (
            <Spinner />
        )
    }
    else {
        let degreeOptions = [<option key="000" value={''}></option>]
        for (let i = 0; i < Object.keys(uniqueDegrees).length; i++) {
            degreeOptions.push(<option key={Object.values(uniqueDegrees)[i]} value={Object.values(uniqueDegrees)[i]}>{Object.values(uniqueDegrees)[i]}</option>)
        }

        let specialtyOptions = [<option key="000" value={''}></option>]
        if (exerciseTeam == "31") {
            specialtyOptions  = specialtyTeam31Options;

        } else {
            for (let i = 0; i < Object.keys(SpecialtyLookUpDerm).length; i++) {
                specialtyOptions.push(<option key={i} value={Object.keys(SpecialtyLookUpDerm)[i]}>{Object.keys(SpecialtyLookUpDerm)[i]} - {Object.values(SpecialtyLookUpDerm)[i]}</option>)
            }
        }

       

        let targetOptions21 = [
            <option key="" value=""></option>,
            <option key="A" value="A">A</option>,
            <option key="B" value="B">B</option>,
            <option key="C" value="C">C</option>,
            //<option key="E" value="E">E</option>,
            //<option key="NPP" value="NPP">NPP</option>,
            <option key="NT" value="NT">NT</option>
        ]

        let targetOptions11 = [
            <option key="" value=""></option>,
            <option key="A" value="A">A</option>,
            <option key="B" value="B">B</option>,
            <option key="C" value="C">C</option>,
            <option key="E" value="E">E</option>,
            <option key="NT" value="NT">NT</option>
        ]

        let targetOptions12 = [
            <option key="" value=""></option>,
            <option key="A" value="A">A</option>,
            <option key="B" value="B">B</option>,
            <option key="C" value="C">C</option>,
            <option key="NT" value="NT">NT</option>
        ]

        let targetOptions31 = [
            <option key="" value=""></option>,
            <option key="A" value="A">A</option>,
            <option key="B" value="B">B</option>,
            <option key="C" value="C">C</option>,
            <option key="NT" value="NT">NT</option>
        ]

        let tgtOptions = [
            <option key="" value=""></option>,
            <option key="Y" value="Y">Y</option>,
            <option key="N" value="N">N</option>
        ]

        let exerciseTeam = currentExercise.TEAM

        let targetOps
        switch (exerciseTeam) {
            case 11:
                targetOps = targetOptions11
                break
            case 12:
                targetOps = targetOptions12
                break
            case 31:
                targetOps = targetOptions31
                break
            default:
                targetOps = targetOptions21
                break
        }

        let stateOptions = [<option key="000" value={''}></option>]
        for (let i = 0; i < Object.keys(states).length; i++) {
            stateOptions.push(<option key={Object.keys(states)[i]} value={Object.keys(states)[i]}>{Object.values(states)[i]}</option>)
        }

        let customerType = currentExercise.CUSTOMER_TYPE

        const searchFields = (exerciseTeam == 31) ? [
            <Field key="FIRST_NAME" title="FIRST NAME" index={'FIRST_NAME'} value={searchParams} onChange={setSearchParams} />,
            <Field key="LAST_NAME" title="LAST NAME" index={'LAST_NAME'} value={searchParams} onChange={setSearchParams} />,
            <Field key="DEGREE" title="DEGREE" index={'DEGREE'} options={degreeOptions} value={searchParams} onChange={setSearchParams} />,
            <Field key="SPECIALTY" title="SPECIALTY" index={'SPECIALTY'} options={specialtyOptions} value={searchParams} onChange={setSearchParams} />,
            <Field key="CURRENT_TARGET_TYPE" title="CURRENT TARGET" index={'CURRENT_TARGET_TYPE'} options={targetOps} value={searchParams} onChange={setSearchParams} />,
            <Field key="CHANGED_TARGET_VALUE" title="FINAL TARGET" index={'CHANGED_TARGET_VALUE'} options={targetOps} value={searchParams} onChange={setSearchParams} />,
            <Field key="CITY" title="CITY" index={'CITY'} value={searchParams} onChange={setSearchParams} />,
            <Field key="STATE" title="STATE" index={'STATE'} options={stateOptions} value={searchParams} onChange={setSearchParams} />
        ] :
            (exerciseTeam == 13 || exerciseTeam == 14 || exerciseTeam == 15)?
        [
            <Field key="FIRST_NAME" title="FIRST NAME" index={'FIRST_NAME'} value={searchParams} onChange={setSearchParams} />,
            <Field key="LAST_NAME" title="LAST NAME" index={'LAST_NAME'} value={searchParams} onChange={setSearchParams} />,
            <Field key="DEGREE" title="DEGREE" index={'DEGREE'} options={degreeOptions} value={searchParams} onChange={setSearchParams} />,
            <Field key="CURRENT_TARGET_TYPE" title="CURRENT TARGET" index={'CURRENT_TARGET_TYPE'} options={targetOps} value={searchParams} onChange={setSearchParams} />,
            <Field key="CHANGED_TARGET_VALUE" title="FINAL TARGET" index={'CHANGED_TARGET_VALUE'} options={targetOps} value={searchParams} onChange={setSearchParams} />,
            <Field key="CITY" title="CITY" index={'CITY'} value={searchParams} onChange={setSearchParams} />,
            <Field key="STATE" title="STATE" index={'STATE'} options={stateOptions} value={searchParams} onChange={setSearchParams} />,
        ]:
        [
            <Field key="FIRST_NAME" title="FIRST NAME" index={'FIRST_NAME'} value={searchParams} onChange={setSearchParams} />,
            <Field key="LAST_NAME" title="LAST NAME" index={'LAST_NAME'} value={searchParams} onChange={setSearchParams} />,
            <Field key="DEGREE" title="DEGREE" index={'DEGREE'} options={degreeOptions} value={searchParams} onChange={setSearchParams} />,
            <Field key="CURRENT_TARGET_TYPE" title="CURRENT TARGET" index={'CURRENT_TARGET_TYPE'} options={targetOps} value={searchParams} onChange={setSearchParams} />,
            <Field key="CHANGED_TARGET_VALUE" title="FINAL TARGET" index={'CHANGED_TARGET_VALUE'} options={targetOps} value={searchParams} onChange={setSearchParams} />,
            <Field key="CITY" title="CITY" index={'CITY'} value={searchParams} onChange={setSearchParams} />,
            <Field key="STATE" title="STATE" index={'STATE'} options={stateOptions} value={searchParams} onChange={setSearchParams} />
            
        ]

        return (
            <div className={styles.search} style={props.preview ? {height: 'calc(100% - 50px)'} : undefined}>
                <TopBar {...props} config={config} data={data} terr={terrID} loaded={config && !loaded} searchParams={searchParams} backButtonUsers={["ADMIN", "OAS", "OBD", "DBD", "IDD"]} name={currentExercise.NAME} search={search} setData={setData} setTotalResults={setTotalResults} setLoaded={setLoaded} export={true} clear={clear}>
                    {searchFields}
                </TopBar>
                <StatusBar {...props} status={status} perTargetTotals={perTargetTotals} id={targetexid} team={exerciseTeam} terr={terrID} getTotals={getTotals} lock={lock} />
                <div className={styles.results} ref={props.tableRef}>
                    <Table styles={[styles.table]}>
                        <Titles {...props} search={search} getTotals={getTotals} config={config} data={data} setData={setData} resetSort={resetSort} setResetSort={setResetSort} />
                        <Results {...props} status={status} id={targetexid} terr={terrID} search={search} getTotals={getTotals} idField={"PROF_ID"} result={customerType === "HCP" ? ResultHCP : ResultHCO} config={config} data={data} loaded={loaded} lock={props.approved || lock} currentPage={currentPage} resultsPerPage={resultsPerPage} options={options} />
                    </Table>
                </div>
                <Pagination {...props} currentPage={currentPage} setCurrentPage={setCurrentPage} resultsPerPage={resultsPerPage} setResultsPerPage={setResultsPerPage} totalResults={totalResults} setTotalResults={setTotalResults} setProperties={(newCurrentPage, newResultsPerPage) => {
                        if (newCurrentPage !== currentPage) {
                            setCurrentPage(newCurrentPage)
                        }
                        if (newResultsPerPage !== resultsPerPage) {
                            setResultsPerPage(newResultsPerPage)
                        }
                    }}/>
            </div>
        )
    }
}

export default Search
